import React, { useRef, useState } from 'react';
import { useComponents } from '@tencent/dz-elements';
import { CardSpaceWrapper } from '../../../components';
import { useMessageById } from '../../../hooks';
import styles from './style/index.less';
import { useReportService } from './useReportService';
import DoctorModal from './DoctorModal';
import DoctorHeader from './DoctorHeader';
var DoctorCard = function (props) {
    var messageId = props.messageId;
    var messageState = useMessageById(messageId);
    var content = messageState.payload.content;
    var View = useComponents().View;
    var _a = useState(false), showModal = _a[0], setShowModal = _a[1];
    var doctorRef = useRef(0);
    var currentTimeRef = useRef(0);
    var report = useReportService({ content: content, doctorIndex: doctorRef.current });
    var onShowDetail = function (index) {
        report.doctorClick(index);
        doctorRef.current = index;
        setShowModal(true);
        currentTimeRef.current = new Date().getTime();
        report.doctorModalExposure(index);
    };
    var isUnique = content.length === 1;
    return (React.createElement(View, null,
        React.createElement(CardSpaceWrapper, { className: styles['doctor-card'] }, content.map(function (doctor, index) { return (React.createElement(View, { key: index, onClick: function () { return onShowDetail(index); }, id: "card_" + doctor.id },
            React.createElement(View, { className: styles['doctor-item-wrap'] },
                React.createElement(DoctorHeader, { doctorData: doctor, type: 'card', isUnique: isUnique }),
                isUnique && doctor.award && React.createElement(View, { className: styles['doctor-award'] }, doctor.awardDesc ? "\u3010" + doctor.award + "\u3011" + doctor.awardDesc : "\u3010" + doctor.award + "\u3011")),
            !isUnique && index !== content.length - 1 && React.createElement(View, { className: styles['doctor-divider-wrap'] },
                React.createElement(View, { className: styles['doctor-divider'] })))); })),
        React.createElement(DoctorModal, { doctor: content[doctorRef.current], show: showModal, currentTime: currentTimeRef.current, reportModuleParams: report.reportModuleParams, onHide: function () {
                setShowModal(false);
            } })));
};
export default DoctorCard;
